import { NavLink } from 'react-router-dom';

// ︎ is the text-presentation selector: it forces ♥ ♀ ♂ to render as monochrome text
// glyphs instead of color emoji (which iOS otherwise does, dropping them onto the lower,
// larger emoji baseline and misaligning Bride/Groom against the other tabs).
const TEXT = String.fromCharCode(0xfe0e); // U+FE0E text-presentation selector — forces monochrome, not emoji
const tabs = [
  { to: '/overview', label: 'Overview', glyph: '▦' },
  { to: '/couple', label: 'Couple', glyph: `♥${TEXT}` },
  { to: '/bride', label: 'Bride', glyph: `♀${TEXT}` },
  { to: '/groom', label: 'Groom', glyph: `♂${TEXT}` },
  { to: '/register', label: 'Register', glyph: '✎' },
] as const;

export function TabBar() {
  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: 'var(--maxw)',
        height: 'calc(var(--tabbar-h) + env(safe-area-inset-bottom))',
        paddingBottom: 'env(safe-area-inset-bottom)',
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        background: 'rgba(10,10,10,0.92)',
        backdropFilter: 'blur(12px)',
        borderTop: '1px solid var(--border)',
      }}
    >
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          style={({ isActive }) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
            color: isActive ? 'var(--white)' : 'var(--text-dim)',
            fontSize: 11,
            letterSpacing: '0.02em',
          })}
        >
          <span
            aria-hidden
            style={{
              fontSize: 18,
              lineHeight: 1,
              height: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.glyph}
          </span>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
